import Backdrop from "@mui/material/Backdrop"
import CircularProgress from "@mui/material/CircularProgress"

export default function SimpleBackdropLoader({ showLoader }) {
    return (
        <div>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={showLoader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}
